// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__MTQ1b","arrow":"Tooltip_arrow__S2IVT"};